import React from 'react';

const TopBar = ({
  sidebarVisible,
  setSidebarVisible,
  selectedModel,
  setSelectedModel,
  activeTab,
  setActiveTab,
  documentRewriterMode
}) => {
  return (
    <div className="top-bar">
      <div className="top-bar-left">
        <button
          onClick={() => setSidebarVisible(!sidebarVisible)}
          className="sidebar-toggle"
          title={sidebarVisible ? "Hide sidebar" : "Show sidebar"}
        >
          {sidebarVisible ? '◀' : '▶'}
        </button>

        {/* Model selector on the left */}
        <div className="model-selector-left">
          <select
            value={selectedModel}
            onChange={(e) => setSelectedModel(e.target.value)}
            className="model-dropdown"
          >
            <option value="gpt-5.2">GPT-5.2</option>
            <option value="gpt-5.1">GPT-5.1</option>
            <option value="gpt-4.1">GPT-4.1</option>
            <option value="gpt-4.1-mini">GPT-4.1 Mini</option>
            <option value="gpt-4o">GPT-4o</option>
            <option value="gpt-4o-mini">GPT-4o Mini</option>
          </select>

        </div>
      </div>

      {/* Tab Navigation */}
      <div className="tab-navigation">
        <button
          className={`tab-button ${activeTab === 'chat' ? 'active' : ''}`}
          onClick={() => setActiveTab('chat')}
        >
          💬 Chat
        </button>
        <button
          className={`tab-button ${activeTab === 'memory' ? 'active' : ''}`}
          onClick={() => setActiveTab('memory')}
        >
          🧠 Memory
        </button>

        {/* Document Rewriter Mode Indicator */}
        {documentRewriterMode && (
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            padding: '4px 8px',
            backgroundColor: 'rgba(74, 222, 128, 0.1)',
            border: '1px solid rgba(74, 222, 128, 0.3)',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            color: 'var(--success-color)',
            marginLeft: '8px'
          }}>
            🔄 LangGraph Document Rewriter Active
          </div>
        )}
      </div>
    </div>
  );
};

export default TopBar;
